import { useRef, useEffect, useState } from "react";
import { Link } from "react-router-dom";

const LinkImage = ({ slug, title, image }) => {
	// const underline = useRef();

	// const [lineSize, setLineSize] = useState(0);

	// useEffect(() => {
	// 	if (!underline.current) return;

	// 	const resizeObserver = new ResizeObserver(() => {
	// 		const { width } = underline.current.getBoundingClientRect();
	// 		setLineSize(Math.floor(width));
	// 	});

	// 	resizeObserver.observe(underline.current);

	// 	return () => resizeObserver.disconnect();
	// });

	const [offset, setOffset] = useState({ x: 0, y: 0 });

	const handleMouseMove = (e) => {
		const { width, height, left, top } = e.currentTarget.getBoundingClientRect();

		// Calculate mouse position relative to the container
		const xRelative = e.clientX - left;
		const yRelative = e.clientY - top;

		// Calculate percentage from center (-50 to 50)
		const xPercent = (xRelative / width - 0.5) * 30;
		const yPercent = (yRelative / height - 0.5) * 30;

		setOffset({
			x: xPercent.toFixed(2),
			y: yPercent.toFixed(2),
		});
	};

	const handleMouseLeave = () => {
		// Optional: Reset to center when the mouse leaves
		setOffset({ x: 0, y: 0 });
	};

	return (
		<Link
			to={slug}
			className={`link-image underline-target`}
			onMouseMove={handleMouseMove}
			onMouseLeave={handleMouseLeave}
			style={{ "--rotateX": `${offset.y}deg`, "--rotateY": `${offset.x}deg` }}>
			<div className="image">
				<img src={image} alt={`${title} Background`} />
			</div>
			{/* <div className="title underline-wrapper underline-top"> */}
			<div className="title">
				<span>{title}</span>
				{/* <div className="underline" ref={underline}>
					<div className="underline-value">{lineSize}</div>
					<div className="underline-left"></div>
					<div className="underline-right"></div>
				</div> */}
			</div>
		</Link>
	);
};

export default LinkImage;
